import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import DesktopWindowsOutlinedIcon from "@mui/icons-material/DesktopWindowsOutlined";
//import AddchartOutlinedIcon from "@mui/icons-material/AddchartOutlined";
import SlideshowOutlinedIcon from "@mui/icons-material/SlideshowOutlined";

const dashboard = {
  id: "group-dashboard",
  title: "Dashboard",
  admin: false,
  type: "group",
  children: [
    {
      id: "combine",
      title: "통합대시보드",
      type: "item",
      url: "/dashboard-reform",
      icon: DashboardOutlinedIcon,
      breadcrumbs: false,
    },

    {
      id: "respectively",
      title: "개별대시보드",
      type: "item",
      url: "/dashboard/respectively",
      icon: DesktopWindowsOutlinedIcon,
      breadcrumbs: false,
    },

    {
      id: "slide_board",
      title: "현황판",
      type: "item",
      url: "/dashboard/slide",
      icon: SlideshowOutlinedIcon,
      breadcrumbs: false,
    },

    // {
    //   id: "slide_map",
    //   title: "지도",
    //   type: "item",
    //   url: "/dashboard/map",
    //   icon: SlideshowOutlinedIcon,
    //   breadcrumbs: false,
    // },

    // {
    //   id: "predict",
    //   title: "예측대시보드",
    //   type: "item",
    //   url: "/dashboard/predict",
    //   icon: AddchartOutlinedIcon,
    //   breadcrumbs: false,
    // },

    // {
    //   id: "region",
    //   title: "지역별",
    //   type: "item",
    //   url: "/dashboard/region",
    //   icon: AddchartOutlinedIcon,
    //   breadcrumbs: false,
    // },
  ],
};

export default dashboard;
